<template>
  <router-link v-if="roles.includes('student')" :to="to" :class="[
  'menu-item__link',
    {'menu-item__link--1': currentLevel == 1 || currentLevel ==2 },
    {'menu-item__link--3': currentLevel ==3 },
    {'menu-item__link--4': currentLevel ==4 },
  ]" 
  active-class="menu-item__link--active" exact>
    <span class="menu-item__title" @click="$emit('call-link-practices')">
      {{ $t(i18n) || name }}
    </span>
    <div class="menu-item__icon" v-if="currentLevel == 3 ">
      <img v-if="icon" class="menu-item__icon-holder" :src="require(`@/assets/icons/menu/${getIcon()}`)" :alt="icon" />
    </div>
    <div class="menu-item__icon" v-if="currentLevel == 1 || currentLevel ==2">
      <img v-if="icon" class="menu-item__icon-holder" :src="require(`@/assets/icons/menu/${getIcon()}`)" :alt="icon" />
    </div>
    <div class="menu-item__icon" v-if="currentLevel == 4 || !currentLevel">
      <img v-if="icon" class="menu-item__icon-holder" :src="require(`@/assets/icons/menu/${getIcon()}`)" :alt="icon" />
    </div>
  </router-link>
  <router-link v-else="roles.includes('tutor')" :to="to" class="tutor">
    <div class="menu-item__icon">
      <img v-if="icon" class="menu-item__icon-holder" :src="require(`@/assets/icons/menu/${getIcon()}`)" :alt="icon" />
    </div>
    <span class="name" :class="[{'show':togleTutor===true}]" @click="$emit('call-link-practices')">
      {{ $t(i18n) || name }}
    </span>
  </router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'VerticalNavMenuItem',
  props: {
    icon: { type: String, default: null },
    i18n: { type: String, required: true },
    name: { type: String, required: true },
    to: { type: [String, Object, null], default: null },
  },
  computed: {
    ...mapGetters({
      roles: 'auth/roles',
      togleTutor:'app/togleTutor',
      currentLevel:'getCurrentLevel',
      })
   },
  created() {
        console.log(this.$route.params.lesson_id)
        if(this.name==='practices'&& this.roles.includes('student')){
            this.name='State test'
        }
       },
  methods: {
    getIcon(){
      let updateIcon;
      updateIcon=this.icon;
      if (this.currentLevel == 1 || this.currentLevel ==2){
        switch (updateIcon) {
          case 'home.png':
            updateIcon='new_menu_icons/Boton_Home.svg'
            break;
          case 'books.png':
            updateIcon='new_menu_icons/Boton_e-library.svg'
            break;
          case 'dictionary.svg':
            updateIcon='new_menu_icons/Boton_dictionary.svg'
            break;
          case 'info.svg':
            updateIcon='new_menu_icons/Boton_help.svg'
            break;
          case 'laptop-computer.svg':
            updateIcon='new_menu_icons/Boton_Practices.svg'
            break;
          case 'language.png':
            updateIcon='new_menu_icons/Boton_language.svg'
            break;
          case 'logout.png':
            updateIcon='new_menu_icons/Sign_out_icono.svg'
            break;
          default:
            break;
        }
      }
      if (this.currentLevel == 3){
        switch (updateIcon) {
          case 'home.png':
            updateIcon='new_menu_icons/iconosMiddleSchool/Home.svg'
            break;
          case 'books.png':
            updateIcon='new_menu_icons/iconosMiddleSchool/e-library.svg'
            break;
          case 'dictionary.svg':
            updateIcon='new_menu_icons/iconosMiddleSchool/Dictionary.svg'
            break;
          case 'info.svg':
            updateIcon='new_menu_icons/iconosMiddleSchool/Help.svg'
            break;
          case 'laptop-computer.svg':
            updateIcon='new_menu_icons/iconosMiddleSchool/Prectice.svg'
            break;
          case 'language.png':
            updateIcon='new_menu_icons/iconosMiddleSchool/Language.svg'
            break;
          case 'logout.png':
            updateIcon='new_menu_icons/iconosMiddleSchool/MLms-09.svg'
            break;
          case 'Boton_Worksheets.svg':
            updateIcon= 'new_menu_icons/iconosMiddleSchool/MLms-13.svg'
          break; 
          default:
            break;
        }
      }
      if (this.currentLevel == 4){
        switch (updateIcon) {
          case 'home.png':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_home.svg'
            break;
          case 'books.png':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_library.svg'
            break;
          case 'dictionary.svg':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_dictionary.svg'
            break;
          case 'info.svg':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_help.svg'
            break;
          case 'laptop-computer.svg':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_practice.svg'
            break;
          case 'language.png':
            updateIcon='new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_language.svg'
            break;
          case 'logout.png':
            updateIcon='new_menu_icons/iconosHighSchool/Boton_sign_out.svg'
            break;
          case 'Boton_Worksheets.svg':
            updateIcon= 'new_menu_icons/iconosHighSchool/Boton_Worksheets.svg'
          break;
          default:
            break;
        }
      }
      if(this.roles.includes('tutor')){
        if(this.name==='Children'){
          updateIcon="tutor/Icon_menu_1.svg"
        }
        if(this.name==='settings'){
           updateIcon="tutor/Icon_menu_2.svg"
        }
        if(this.name==='help'){
           updateIcon="tutor/Icon_menu_3.svg"
        }
        /*if(this.name==='SignOut'){
          updateIcon=''
        }*/
      }
      return updateIcon;
    }
  }, 
};
</script>
<style lang="scss">
$color-text-blue: #3960A5;
$color-text-yellow: #f3ad31;
.el-dialog{
  height: 90vh !important;
}
.tutor{
  display: flex;
  align-items: center;
  .menu-item{
    &__icon{
    //  width: 100px;
    }
    &__icon-holder{
      width: 50px;
      height: 50px;
    }
  }
  .name{
    color: white;
    display: none;
    padding-left: 3px;
    &:hover{
      font-weight: 600;
    }
  }
}
/*.tutor:last-of-type {
  justify-content: center;
  border-bottom: 1px solid white;
  padding-bottom: 1.2rem;
  max-width: 120px;
  margin: 0 auto;
}*/
.show{
  display: block !important;
}
.menu-item{
  &__link {
    text-decoration: none;
    transition: all .3s ease;
    display: grid;
    margin: 1rem 0;
    grid-template-columns: repeat(2, 1fr);
    font-size: 1em;
    &:hover{
       background-color: rgba($color: #f3ad31, $alpha: .9);
       span{
          color: white;
        }
    }
    &__active {
      border-radius: 4px;
      color: rgba(white,1);
      &:hover{
        color: rgba(white,1);
      }
    }
  }
  &__icon-holder {
    height: 25px;
    width: 25px;
  }
  &__title{
    font-family: "FuturaBold", Helvetica, Arial;
    display: flex;
    align-items: center;
    color: white;
    font-size: 0.9rem;
    line-height: 18px;
    padding-left: 1rem;
  }
  &__is-minimized{
    .menu-item {
      &__title{
        display: none;
      }
      &__icon-holder{
        min-width: unset;
      }
    }
  }
}
.menu-item--is-minimized.menu-item__link{
  justify-content: center;
}
.menu-item {
  &__link{
    padding: 0;
    overflow: hidden;
    &:nth-child(5){
      display: none;
    }
    &:nth-child(8){
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      .menu-item__title {
        color: white;
        text-align: right;
      }
      .menu-item__icon {
        padding-left: 0.5rem;
        img{
          width: 2rem;
        }
      }
    }
  }
  &__link--1{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-radius: 10px;
    margin: 1rem;
    background-color: white;
    height: 60px;
    .menu-item__title {
      color: $color-text-blue ;
      padding-left: 12px;
    }
    .menu-item__icon {
      text-align: right;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      color: white;
      img{
        height: 100%;
      }
      &-holder{
        height: unset;
        width: unset;
      }
    }
  }
  &__link--3{
    display: grid;
    grid-template-columns: 70% 30%;
    margin: 1rem 1rem;
    background: white;
    border-radius: 40px;
    height: 40px;
    .menu-item__icon{
      text-align: right;
       img{
          width: 60%;
          height: 100%;
        }
    }
    .menu-item__title{
      color: $color-text-yellow;
      font-family: "FuturaBold", Helvetica, Arial;
    }
  }
  &__link--4{
    display: grid;
    grid-template-columns: 50% 50%;
    border-radius: 10px;
    margin: 1rem;
    background-color: white;
    padding: unset !important;
    height: 52px;
    .menu-item__title {
      color: $color-text-blue ;
      padding-left: 12px;
      font-size: 0.7rem;
    }
     .menu-item__icon {
      text-align: right;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      color: white;
      img{
        height: 100%;
        width: 100%;
      }
      &-holder{
        height: unset;
        width: unset;
      }
    }
  }
}

  .show-item{
    display: grid !important;
  }
</style>
